import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock'
import { getNumTitles } from '@App/helpers/pagination/get-num-titles'
import { PaginationBody } from '@Entities/pagination'
import CSWorkItemTable from '@Scenes/RightsholderScene/MatchClaim/Claim/ClaimSearch/ClaimSearchPaginationTable/CSWorkItemTable'
import PaginationAndLimit from '@Components/Navigations/PaginationAndLimit'

interface ClaimSearchPaginationTableProps {
    selectWork: (id: number | null | undefined) => void
    limit: number
    onChangePage: (body: PaginationBody) => void
    onChangeLimit: (newLimit: number) => void
}

const ClaimSearchPaginationTable = (props: ClaimSearchPaginationTableProps) => {
    const { claimingToolSearchStore } = useContext(StoresContext)
    const { selectWork, onChangePage, onChangeLimit, limit } = props

    const results = claimingToolSearchStore.unclaimedWorks

    if (!results) {
        return <></>
    }
    const currentPagination = claimingToolSearchStore.unclaimedWorksPaginationInfo
    const currentPage = currentPagination ? currentPagination.currentPage : 1

    return (
        <>
            <PaginationResultsBlock
                totalResults={results.count}
                workNumTitles={getNumTitles(results.count, currentPage, limit)}
            />
            <CSWorkItemTable workModels={results.works} selectWork={selectWork} />
            {results.count !== 0 && (
                <PaginationAndLimit
                    count={results.count}
                    limit={limit}
                    paginationInfo={currentPagination}
                    onPageChange={onChangePage}
                    onLimitChange={onChangeLimit}
                />
            )}
        </>
    )
}

export default observer(ClaimSearchPaginationTable)
